import { useApolloClient } from '@apollo/react-hooks';

const useApiClient = (...args) => (
  useApolloClient(...args)
);

export default useApiClient;
